import type { CycleOperatorSummary } from "./types";

export function summarizeEntrySubmissionFreezeBanner(
  cycle?: Pick<CycleOperatorSummary, "entrySubmissionFreeze"> | null,
) {
  if (!cycle?.entrySubmissionFreeze) return null;
  return {
    tone: "amber" as const,
    title: "진입 제출 동결",
    detail: "discipline-flat — 신규 진입 차단 · reduceOnly 청산 허용 · eval/ingest 계속",
  };
}
